import AlertRequestQuery from "~/entities/AlertRequestQuery";
import ValidationModule from "~/entities/ValidationModule";

export default class ValidationTracking extends ValidationModule {
  public trackingAlerts = {
    selector: {
      trackingNumber: "TrackingPageError",
    },
    needle: [""],
  };

  public constructor() {
    super("");
    this.resetValidations();
    this.alertNames = [
      "TrackingPageError", // We we're unable to track your package. Double check that this is a valid UPS tracking number and try again.
    ];
    this.alertTypes = {
      trackingNumber: this.trackingAlerts,
    };
  }

  public async Validate(scope: string = "") {
    this.resetValidations();
    const tracking = this.component?.tracking;
    if (!tracking) return false;
    if (tracking.trim().length > 20) {
      return false;
    }
    const escapedString = String(tracking)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

    return escapedString === tracking;
  }

  public resetValidations() {
    this.validated = false;
    this.validationMade = false;
    this.validationErrors = [];
    this.component?.clearActiveNotices();
  }

  public requestAlert(data: any) {
    this.component?.requestAlert(this.getFilteredAlertKey(data, "asObject"));
  }

  public addNotice(data: any) {
    this.component?.addNotice(this.getFilteredAlertKey(data));
  }

  public removeNotice(data: any) {
    this.component?.removeNotice(this.getFilteredAlertKey(data));
  }

  protected getFilteredAlertKey(
    data: any,
    returnType: string = "asString"
  ): any {
    const keyGetter = new AlertRequestQuery();
    if (data.hasOwnProperty("type")) {
      switch (data.type) {
        case "trackingNumber":
          keyGetter.name = this.alertTypes[data.type].selector[data.type];
          break;
      }
    } else {
      // fill
    }
    const filteredData = keyGetter.getKey(
      this.alertNames,
      this.alertTypes[data.type]
    );
    if (returnType === "asString") {
      return filteredData.name;
    } else {
      return filteredData;
    }
  }
}
